import { render, staticRenderFns } from "./QuestionReports.vue?vue&type=template&id=d84106ca&scoped=true&"
import script from "./QuestionReports.vue?vue&type=script&lang=js&"
export * from "./QuestionReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84106ca",
  null
  
)

export default component.exports